<!-- Toolbar Section -->
<mat-toolbar class="custom-toolbar">
    <div class="logo-container">
        <img src="../assets/images/logo.svg" alt="Inforida Logo" class="logo" />
    </div>
    <div class="menu-container">
        <button type="button" mat-button routerLink="/" class="nav-item">Home</button>
        <button mat-button routerLink="/platform" class="nav-item">Platform</button>
        <button mat-button routerLink="/ecosystem" class="nav-item">Ecosystem</button>
        <button mat-button routerLink="/about-us" class="nav-item">About us</button>
        <button mat-button routerLink="/resource" class="nav-item">Resource</button>
        <button mat-button routerLink="/contact" class="nav-item">Contact us</button>
        <button mat-button routerLink="/post-job" class="nav-item post-job-btn">Post A Job</button>
    </div>
</mat-toolbar>